module.exports = __webpack_public_path__ + "static/media/doyou-logo_2026.7fc2e7ee.svg";